import { restApi } from '../../api';
import {
  GetProductColorSelloutMetricsParams,
  GetProductColorsSelloutTotalsParams,
  SelloutProductColor,
  SelloutTotalsProductColor,
} from './product-color-sellout.types';

export const onlineProductColorSelloutRepository = {
  getProductColorSelloutMetrics: (params: GetProductColorSelloutMetricsParams) =>
    restApi.get<SelloutProductColor>(`/sellout/metrics/product-color/${params.productColorId}`, {
      orderId: params.orderId,
    }),

  getTotalProductColorsSellout: (params: GetProductColorsSelloutTotalsParams) =>
    restApi.get<SelloutTotalsProductColor[]>('/sellout/metrics/totals', params),
};
